document.addEventListener('DOMContentLoaded', () => {
    // slick default setting
    let defaulsettings = {
        loop: true,
        speed: 1000,
        effect: 'fade',
        fadeEffect: {
            crossFade: true
        },
        navigation: {
            nextEl: ".sw-gal-next",
            prevEl: ".sw-gal-prev",
        },
        autoplay: {
            delay: 11000,
            disableOnInteraction: false
        },
        on: {
            autoplayTimeLeft(s, time, progress) {
                const bar = s.pagination && s.pagination.el
                  ? s.pagination.el.querySelector('.custom-progress__bar')
                  : null;
                if (!bar) return;
                bar.style.width = ((1 - progress) * 100) + '%';
            },
            slideChange(s) {
                const bar = s.pagination && s.pagination.el
                  ? s.pagination.el.querySelector('.custom-progress__bar')
                  : null;
                if (bar) bar.style.width = '0%';
            }
        }
    };

    let allSwipper =[];

    document.querySelectorAll('.swiper-slider').forEach((element,i) => {
        let swiperConfig = element.dataset.swiper ? JSON.parse(element.dataset.swiper) : defaulsettings;
        element.setAttribute(`data-swiper-${i}`,"");
        let swiper = new Swiper(`[data-swiper-${i}]`, swiperConfig);
        allSwipper[i] = swiper;

    });

  // Gallery

  const gallerySlider = new Swiper('.gallery_slider--one', {
    slidesPerView: 1,
    speed: 1300,
    loop: true,
    autoplay: {
        delay: 7000,
        disableOnInteraction: false
    },
    navigation: { 
      nextEl: '.sw-gal-next', 
      prevEl: '.sw-gal-prev' 
    },
    pagination: { 
      el: '.swiper-pagination', 
      clickable: true 
    },
    controller: { 
      by: 'slide' 
    } 
  });

  const gallerySliderTwo = new Swiper('.gallery_slider--two', {
    slidesPerView: 1,
    speed: 1000,
    loop: true,
    allowTouchMove: false,
    controller: { 
      by: 'slide' 
    }
  });

  const gallerySliderThree = new Swiper('.gallery_slider--three', {
    slidesPerView: 1,
    speed: 1000,
    loop: true,
    allowTouchMove: false,
    controller: { 
      by: 'slide'
    }
  });

  gallerySlider.controller.control = [gallerySliderTwo, gallerySliderThree];

  // Reviews

  const speed = 2000;

  const swiperReviews = new Swiper('.slider-reviews', {
    slidesPerView: 1.5,           
    spaceBetween: 130,
    speed: speed,
    loop:true,
    allowTouchMove: false,
    navigation: {
      nextEl: '.sw-gal-next',
      prevEl: '.sw-gal-prev'
    },
    pagination: {
      el: '.swiper-pagination',
      clickable: true
    },
    breakpoints: {
        320: {
            slidesPerView: 1
        },
        1023: {
            slidesPerView: 1.5,           
        }
    }
  });

// Slider

  const swiperOne = new Swiper('.slider-one', {
    slidesPerView: 1,
    speed: speed,
    allowTouchMove: true,
    autoplay: {
        delay: 7000,
        disableOnInteraction: false
    },
    keyboard: {
        enabled: true,
    },
    breakpoints: {
        768: {
            allowTouchMove: false,
        }
    }
  });

  const swiperTwo = new Swiper('.slider-two', {
    slidesPerView: 1,
    spaceBetween: 30,
    speed: speed,
    allowTouchMove: true,
    keyboard: {
      enabled: true,
    },
    navigation: {
      nextEl: '.sw-gal-next',
      prevEl: '.sw-gal-prev'
    },
    pagination: {
      el: '.swiper-pagination',
      clickable: true
    },
    breakpoints: {
        768: {
            allowTouchMove: false,
        }
    }

  });

  swiperOne.controller.control = swiperTwo;
  swiperTwo.controller.control = swiperOne;

  function toggleFirstOnLast(sw) {
    const first = sw.slides && sw.slides[0];
    if (!first) return;
    const isLast = sw.activeIndex === sw.slides.length - 1;
    first.classList.toggle('fade-when-last', isLast);
  }

  function updateArrows(sw) {
    const next = document.querySelector('.sw-gal-next');
    const prev = document.querySelector('.sw-gal-prev');
    if (!next || !prev) return;

    if (updateArrows._t) {
      clearTimeout(updateArrows._t);
      updateArrows._t = null;
    }

    next.style.opacity = '0';
    next.style.pointerEvents = 'none';
    prev.style.opacity = '0';
    prev.style.pointerEvents = 'none';

    updateArrows._t = setTimeout(() => {
      const isFirst = sw.activeIndex === 0;
      const isLast  = sw.activeIndex === sw.slides.length - 1;

      if (isFirst) {
        next.style.opacity = '1'; next.style.pointerEvents = 'auto';
        prev.style.opacity = '0'; prev.style.pointerEvents = 'none';
      } else if (isLast) {
        next.style.opacity = '0'; next.style.pointerEvents = 'none';
        prev.style.opacity = '1'; prev.style.pointerEvents = 'auto';
      } else {
        next.style.opacity = '1'; next.style.pointerEvents = 'auto';
        prev.style.opacity = '1'; prev.style.pointerEvents = 'auto';
      }
    }, 500);
  }

  function syncUI() {
    toggleFirstOnLast(this);
    updateArrows(this);
  }

  swiperTwo.on('init', syncUI);
  swiperTwo.on('slideChange', syncUI);

  syncUI.call(swiperTwo);

// Slider History 

  const historyText = new Swiper('.history-slider__text', {
      allowTouchMove: false,
      loop: true,
      speed: 1300,
      spaceBetween: 40,
      autoHeight: true,
      navigation: {
      nextEl: '.sw-gal-next',
      prevEl: '.sw-gal-prev',
      320: {
          slidesPerView: 1,
      },
      1023: {
        slidesPerView: 2.55,
        autoHeight: true,
      }
    }
  });


  const historyMain = new Swiper('.history-slider__main', {
    allowTouchMove: false,
    loop: true,
    speed: 1300,
    spaceBetween: 20,
    breakpoints: {
        320: {
            slidesPerView: 1
        },
        1023: {
            slidesPerView: 2.55
        }
    }
  });

  const historySecondary = new Swiper('.history-slider__secondary', {
      allowTouchMove: false,
      loop: true,
      speed: 1300,
      spaceBetween: 20,
      320: {
          slidesPerView: 1
      },
      1023: {
            slidesPerView: 2.55
      }
  });

  

  historyText.controller.control = [historyMain, historySecondary];



// Testimonials Slider 

  const testimonialsText = new Swiper('.testimonials-slider__text', {
      allowTouchMove: false,
      loop: true,
      speed: 1300,
      spaceBetween: 40,
      navigation: {
        nextEl: '.sw-gal-next',
        prevEl: '.sw-gal-prev'
      },
      breakpoints: {
          320: {
              slidesPerView: 1
          },
          1023: {
              slidesPerView: 2
          }
      }
  });

  const testimonialsMain = new Swiper('.testimonials-slider__main', {
    allowTouchMove: false,
    loop: true,
    speed: 1300,
    spaceBetween: 20,
    breakpoints: {
        320: {
            slidesPerView: 1
        },
        1023: {
            slidesPerView: 2
        }
    }
  });

    testimonialsText.controller.control = testimonialsMain;

     const cardsSlider = new Swiper('.cards-slider', {
      loop: true,
      slidesPerView: 1,
      speed: 800,
      spaceBetween: 40,
      autoHeight: true,
      effect: 'fade',
      fadeEffect: {
        crossFade: true
      },
      navigation: {
      nextEl: '.sw-gal-next',
      prevEl: '.sw-gal-prev',
    }
  });


});
